<template>
    <div class="w-full h-full flex antialiased bg-white text-zinc-900 dark:bg-neutral-950 dark:text-slate-300 ">
        <div class="w-full h-full">
            <div class="w-full h-[calc(100vh)]">
                <div class="h-full w-full">
                   
                    



                    <div class="w-full h-screen flex flex-col-reveresed">

                     <div class="logo_login_div object-cover object-center h-screen w-7/12">
                        <img src="../assets/img/back1.jpg" alt="background" class="logo_login_img_back object-cover object-center h-screen w-12/12">
                        <img src="../assets/img/logo.png" alt="background2" class="logo_login_img object-center  w-12/12">
                    </div>
                    <div class="flex flex-col justify-center items-center w-5/12 shadow-lg bg-white/80 dark:bg-zinc-900/60 backdrop-blur-sm rounded-md">
                        <h1 class="text-3xl font-bold text-blue-500 mb-2">Vybroo Panel</h1>
                        <div class="w-1/2 text-center">
                            <input type="text" name="username" placeholder="Usuario" autocomplete="off" class="shadow-md border w-full h-10 px-3 py-2 text-zinc-900 dark:text-zinc-100 bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 focus:outline-none focus:border-indigo-500 mb-3 rounded">
                            <input type="password" name="password" placeholder="Contraseña" autocomplete="off" class="shadow-md border w-full h-10 px-3 py-2 text-zinc-900 dark:text-zinc-100 bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 focus:outline-none focus:border-indigo-500 mb-3 rounded">
                            <button class="bg-indigo-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-lg focus:outline-none shadow">Iniciar</button>
                        </div>
                    </div>
                    </div>




                    
                </div>
            </div>
        </div>
    </div>
</template>
<script> 
//import axios from 'axios';

export default {
    components: {   },
    data() {
        return {
            token: '', 
        };
    },
    
    methods: { 
        /*loadClient () {
            //const clientId = { id:this.mLoginInput.toLowerCase() };
            const dataParameters = {
                token: this.token, 
            };
            axios.post("http://panel.vybroo.net/user", dataParameters)
            .then(response => {
                if (response.data) {
                    console.log(response.data);
                    if(response.data.error == true){
                        if(response.data.error == true) console.log("El canal no existe.");
                            console.log("Error al obtener el usuario: "+response.data.error);
                    } else {
                        console.log("Usuario encontrado");
                        localStorage.setItem('clientData', JSON.stringify(response.data.user));
                        console.log(JSON.parse(localStorage.getItem('clientData')));
                    }
                }else{
                        console.log("AXIOS---no_response");
                }
            })
            .catch(error => {
                console.error("conectados: There was an error!", error);
            }); 
        },*/
    },
    mounted() {
        //const tokenId = this.$route.params.token;
        //this.token = tokenId; 
        //this.loadClient();
        // verificar si el storage esta vacio, si esta vacio redireccionar a login y si no esta vacio redireccionar a dashboard
        console.log("Login=====");
        try {
            const tokenId = JSON.parse(localStorage.getItem('clientData'));
            console.log(tokenId);
            if(tokenId){
                console.log("Storage IS NOT NULL");
                this.$router.push({ name: 'dashboard' });
            }else{
                console.log("Storage IS NULL");
            }
        } catch (error) {
            console.log("Error al obtener el usuario: "+error);
        }

    }
};
</script>

<style>
.logo_login_div{
    position: relative;
}
.logo_login_img{
    left: 50%;
    top: 50%;
    position: absolute;
    transform: translate(-50% , -50%);
    width: 80%;
    margin: auto;
}
.logo_login_img_back {
    filter: brightness(0.4);
}
</style>